"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.18 0c1.328 0 2.379.998 2.46 2.302l.006.164v19.068c0 1.306-1.052 2.377-2.378 2.46l-.167.006H6.82a2.438 2.438 0 0 1-2.462-2.302l-.005-.164V2.466c0-1.328.998-2.379 2.302-2.46L6.82 0h10.36Zm1.506 21.219H5.314v.315c0 .798.59 1.432 1.367 1.5l.14.006H17.1c.825 0 1.505-.603 1.578-1.37l.007-.136v-.315Zm0-17.24H5.314v16.28h13.372V3.979ZM17.18.96H6.82c-.799 0-1.433.59-1.5 1.367l-.007.14v.552h13.372v-.553c0-.798-.59-1.432-1.366-1.5L17.18.96Zm-4.672.55a.48.48 0 0 1 .086.952l-.086.007h-1.033a.48.48 0 0 1-.087-.952l.087-.008h1.033Z",
    clipRule: "evenodd"
  })]
});